
import Vue from "vue";
import NavSideBar from "@/components/candidate/NavSideBar.vue";
import { mapGetters } from "vuex";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";

export default Vue.extend({
  name: "CandidateWrapper",
  components: { NavSideBar },
  computed: {
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    })
  },
  watch: {
    get_user_details() {
      this.reset();
    }
  },
  async created() {
    if (this.get_user_details) await this.reset();
  },
  methods: {
    async reset() {
      // Clean up stale localStorage flags from old implementation
      // Assessment now auto-resumes from saved state, no cancellation on reload
      localStorage.removeItem("assessment_cancelled");
      localStorage.removeItem("assessment");
    }
  }
});
